var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-none shadow ",class:{
    'disable-events': _vm.disabled,
    border: _vm.border,
    padding: _vm.padding,
    'border-yellow': _vm.borderYellow && !_vm.disabled,
  },attrs:{"rounded":"","to":_vm.to,"elevation":"2","loading":_vm.loading,"color":_vm.disabled ? 'grey' : 'white',"small":_vm.small,"x-small":_vm.xsmall,"fab":_vm.fab,"height":_vm.height,"width":_vm.width}},[(_vm.icon)?_c('font-awesome-icon',{class:_vm.iconMargin,attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text))],1)}
var staticRenderFns = []

export { render, staticRenderFns }